import { HttpParams } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Sort_Utils } from 'src/app/entities/Sort_Utils';
import { Anagrafica, StatsTable, UserStats } from 'src/app/entities/various';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { StatsService } from 'src/app/services/stats/stats.service';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.css']
})
export class StatsComponent implements OnInit {
  
  navigator : string = 'sidebar.stats';

  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  me : UserInfo | undefined;
  params : HttpParams;
  sortUtils : Sort_Utils = new Sort_Utils();
  toastConfig : {title: string, class: string} | undefined;
  pages = [{key : 2},{key : 12}, {key : 25}, {key : 50}, {key : 100}];
  resellers : UserInfo[] = [];
  selectedReseller : string | number ='';
  selectedUserState : string ='';

  statsTable : StatsTable | undefined;
  searchFilter : { abilitato? : string, id_utente_reseller? : number | string} = {};

  search : boolean = false;

  nPage = 1;
  pageSize : number = 12;
  startRow: number = 0;
  totalPages: number = 0;
  totalRows: number = 0;

  constructor(private loginService: LoginService, private translate: TranslateService, private statsService : StatsService) {
    this.params = new HttpParams();
    this.params =this.params.append('endRow', 0);
    this.params =this.params.append('lastKeyVal', '');
    this.params =this.params.append('page', 1);
    this.params =this.params.append('pageDirection', 'FORWARD');
    this.params =this.params.append('pageSize', 12);
    this.params =this.params.append('pagination', true);
    this.params =this.params.append('paginationMode', 'SKIP');
    this.params =this.params.append('rows', 0);
    this.params =this.params.append('searchFilter', '{}');
    this.params =this.params.append('sortDir', 'ASC');
    this.params =this.params.append('sortKey', 'username');
    this.params =this.params.append('startRow', 0);
    this.params =this.params.append('totalPages', -1);
    this.params =this.params.append('totalRows', 0);
    this.innerWidth = window.innerWidth;
   }

  async ngOnInit() {
    this.me = await this.loginService.getUserInfo();
    this.resellers = await (await this.statsService.getResellers(this.me!.dms_user_id)).data.data;
  
  }

  setUserState(state : string) {
    this.selectedUserState = state;

  }


  async sort(key: string){
    this.params =this.params.delete('sortKey');
    this.params =this.params.delete('sortDir');
    this.params =this.params.append('sortKey', key);
    this.params =this.params.append('sortDir', this.sortUtils.getSortDir(key));
    await this.getTable();
  }


  async prev(){
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! - 1;
      this.nPage = val;

      this.params = new HttpParams();
      this.params = this.params.append('lastKeyVal', this.statsTable!.data[this.statsTable!.data.length -1].username.replace("\%20","+"));
      this.params =this.params.delete('endRow');
      this.params =this.params.append('page', this.nPage);
      this.params =this.params.append('pageDirection', 'FORWARD');
      this.params =this.params.append('pageSize', this.pageSize);
      this.params =this.params.append('pagination', true);
      this.params =this.params.append('paginationMode', 'SKIP');
      this.params =this.params.append('rows', 0);

      
      this.searchFilter = {};
      if(this.selectedReseller!='') this.searchFilter.id_utente_reseller=this.selectedReseller;
      if(this.selectedUserState! != '') this.searchFilter.abilitato= this.selectedUserState; 
      this.params = this.params.append('searchFilter', JSON.stringify(this.searchFilter));

      this.params =this.params.append('sortDir', 'ASC');
      this.params =this.params.append('sortKey', 'username');
      this.params =this.params.append('startRow', this.startRow);
      this.params =this.params.append('totalPages',this.totalPages);
      this.params =this.params.append('totalRows', this.totalRows);

      await this.getTable();
    }
  }

  async next(){
    if(this.params.get('page') != null){
      let val : number = +this.params.get('page')! + 1;
      this.nPage = val;

      this.params = new HttpParams();
      this.params = this.params.append('lastKeyVal', this.statsTable!.data[this.statsTable!.data.length -1].username.replace(" ","+"));
      this.params =this.params.delete('endRow');
      this.params =this.params.append('page', this.nPage);
      this.params =this.params.append('pageDirection', 'FORWARD');
      this.params =this.params.append('pageSize', this.pageSize);
      this.params =this.params.append('pagination', true);
      this.params =this.params.append('paginationMode', 'SKIP');
      this.params =this.params.append('rows', 0);

      
      this.searchFilter = {};
      if(this.selectedReseller!='') this.searchFilter.id_utente_reseller=this.selectedReseller;
      if(this.selectedUserState! != '') this.searchFilter.abilitato= this.selectedUserState; 
      this.params = this.params.append('searchFilter', JSON.stringify(this.searchFilter));

      this.params =this.params.append('sortDir', 'ASC');
      this.params =this.params.append('sortKey', 'username');
      this.params =this.params.append('startRow', this.startRow);
      this.params =this.params.append('totalPages',this.totalPages);
      this.params =this.params.append('totalRows', this.totalRows);

      await this.getTable();
    }
  }

  async getTable(){
    this.search = true;

    this.statsTable = undefined;
    // this.params = this.params.append('searchFilter', JSON.stringify(this.searchFilter));
    let response = await this.statsService.getTable(this.me!.dms_user_id, this.params);
    if(response.success){
      this.statsTable = response.data;

      this.startRow = response.data.startRow;
      this.totalPages = response.data.totalPages;
      this.totalRows = response.data.totalRows;
      
    }
    this.searchFilter.id_utente_reseller='';
  }

  async changePageSize (pageSize: number) {
    this.pageSize = pageSize;

    this.params = new HttpParams();
    this.params = this.params.append('lastKeyVal', this.statsTable!.data[this.statsTable!.data.length -1].username);
    this.params =this.params.delete('endRow');
    this.params =this.params.append('page', this.nPage);
    this.params =this.params.append('pageDirection', 'FORWARD');
    this.params =this.params.append('pageSize', this.pageSize);
    this.params =this.params.append('pagination', true);
    this.params =this.params.append('paginationMode', 'SKIP');
    this.params =this.params.append('rows', 0);

    
    this.searchFilter = {};
    if(this.selectedReseller!='') this.searchFilter.id_utente_reseller=this.selectedReseller;
    if(this.selectedUserState! != '') this.searchFilter.abilitato= this.selectedUserState; 
    this.params = this.params.append('searchFilter', JSON.stringify(this.searchFilter));

    this.params =this.params.append('sortDir', 'ASC');
    this.params =this.params.append('sortKey', 'username');
    this.params =this.params.append('startRow', this.startRow);
    this.params =this.params.append('totalPages',this.totalPages);
    this.params =this.params.append('totalRows', this.totalRows);

    await this.getTable();

    // this.statsTable = await (await this.statsService.getTable(this.me!.dms_user_id, this.params!)).data;
  }

  getJsonData(u : UserStats) {
    let jdata : Anagrafica =  JSON.parse(u.json_sdi_data);
    return jdata;

  }

}
